import useFetchingMyTickets from "./useFetchingMyTickets";
import useFetchingMyEventConnections from "./useFetchingMyEventConnections";
import { useMemo } from "react";
import { differenceInWeeks } from "date-fns";

const useFetchingMyStats = () => {
  const { data: tickets, isLoading: isFetchingTickets } = useFetchingMyTickets();
  const { connections, isLoading: isFetchingConnections } = useFetchingMyEventConnections();

  const { totalJourneys, weeksSinceFirst } = useMemo(() => {
    if (!tickets) return {};
    const now = new Date();
    
    // Calculate total past events
    const pastEvents = tickets.filter(
      (t) => new Date(t.events.start_time) < now
    );

    // Calculate weeks since first Nimi
    const firstEvent = [...pastEvents].sort(
      (a, b) =>
        new Date(a.events.start_time).getTime() -
        new Date(b.events.start_time).getTime()
    )[0];

    const weeksSinceFirst = firstEvent
    ? differenceInWeeks(now, new Date(firstEvent.events.start_time))
    : 0;
    
    const totalJourneys = pastEvents.length;
    return { totalJourneys, weeksSinceFirst };
  }, [tickets]);

  return {
    totalJourneys,
    weeksSinceFirst,
    connections,
    isLoading: isFetchingTickets || isFetchingConnections,
  }
};

export default useFetchingMyStats;
